import { FPageBlock } from '../../mdl/f-page-block';
import { UILabeled } from '../../ui/component/labeled';
import { $el } from '../../ui/elements';
import { $form } from '../../y/form';
import { EDBlockSpec, EDBlock } from '../block';
import { EDContainerBlock } from '../containerblock';
import { EDBlockContainer } from '../editor';
import { fakeButton } from '../elements';
import { EDSymbolInput } from '../image';

export const ed_page_subscribe_button_block: EDBlockSpec<FPageBlock> = {
    key: 'subscribe_button',
    editor_block: class extends EDBlock {
        constructor(container: EDBlockContainer) {
            const sym = $el.DIV('sym');
            const symbol = new EDSymbolInput(sym);

            const properties = $el.DIV('l-form', [
                new UILabeled(symbol, { above: 'Symbol' }),
            ]);

            super($form({ symbol }), container, 'Subscribe button', properties);

            this.classList.add('blk-subscribebutton');
            this.ui_add([
                sym,
                $el.DIV('r-button', [
                    fakeButton('promo.hero_button', 'k-shadow', ['m-larger', 'ui-tint-blue']),
                    $el.DIV('r-sub', 'subtitle')
                ]),
            ]);
        }
    }
};

export const ed_page_hero_block: EDBlockSpec<FPageBlock> = {
    key: 'new_hero',
    editor_block: class extends EDContainerBlock<FPageBlock> {
        constructor(container: EDBlockContainer) {
            super($form({}), container, 'Hero');
            this.classList.add('blk-hero', 'b', 'b-block');
            this.list.classList.add('r-container');
            this.ui_add(this.list);
        }

        get selection_style() {
            return { radius: 33 };
        }

        get hover_style() {
            return { radius: 29 };
        }
    },
};
